import './src/vaadin-custom-field.js';

export * from './src/vaadin-custom-field.js';
